import { Routes } from '@angular/router';
import { AuthGuard } from '../../app-okc/shared-gz/helpers/auth.guard';

//Route for content layout with sidebar, navbar and footer.

export const Full_ROUTES: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('../../app-okc/auth/auth.module').then(m => m.AuthModule),
    canActivate: [AuthGuard],
  }
];